export const maxEmailFileSize = 25000000 // 25MB

export const newEmailPrefix = '<p/><p/><p/><p/>'

export const unsupportedEmailFileTypes = [
  '.ade',
  '.adp',
  '.apk',
  '.app',
  '.asp',
  '.appx',
  '.aspx',
  '.asx',
  '.appxbundle',
  '.bas',
  '.bat',
  '.cab',
  '.cer',
  '.chm',
  '.cmd',
  '.cnt',
  '.csh',
  '.com',
  '.cpl',
  '.crt',
  '.der',
  '.dll',
  '.diagcab',
  '.dmg',
  '.exe',
  '.fxp',
  '.gadget',
  '.grp',
  '.hlp',
  '.hpj',
  '.hta',
  '.htc',
  '.inf',
  '.ins',
  '.isp',
  '.iso',
  '.its',
  '.jar',
  '.jnlp',
  '.js',
  '.jse',
  '.ksh',
  '.lib',
  '.lnk',
  '.mad',
  '.maf',
  '.mag',
  '.mam',
  '.maq',
  '.mar',
  '.mas',
  '.mat',
  '.mau',
  '.mav',
  '.maw',
  '.mcf',
  '.mda',
  '.mdb',
  '.mde',
  '.mdt',
  '.mdw',
  '.mdz',
  '.msc',
  '.msh',
  '.msh1',
  '.msh2',
  '.mshxml',
  '.msh1xml',
  '.msh2xml',
  '.msi',
  '.msix',
  '.msixbundle',
  '.msp',
  '.msu',
  '.mst',
  '.nsh',
  '.ops',
  '.osd',
  '.pcd',
  '.pif',
  '.pl',
  '.plg',
  '.prf',
  '.prg',
  '.printerexport',
  '.ps1',
  '.ps1xml',
  '.ps2',
  '.ps2xml',
  '.scr',
  '.sct',
  '.shb',
  '.sys',
  '.vb',
  '.vbe',
  '.vbs',
  '.vhd',
  '.vhdx',
  '.vsmacros',
  '.vxd',
  '.ws',
  '.wsc',
  '.wsf',
  '.wsh',
]
